import { render } from "./svg-search.vue?vue&type=template&id=50f5e6b4&lang=pug"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__